export default "__VITE_ASSET__CsYpS78r__"